import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, formatINR } from "../lib/api";
import { useAuth } from "../lib/auth";

const STATUS_LABEL = {
  pending: "Pending",
  confirmed: "Confirmed",
  out_for_delivery: "Out for delivery",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export default function Account() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) nav("/login?next=/account");
  }, [user, nav]);

  useEffect(() => {
    if (!user) return;
    api.get("/orders/mine").then(({ data }) => setOrders(data)).finally(() => setLoading(false));
  }, [user]);

  if (!user) return null;

  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto max-w-6xl px-6 py-14 lg:px-10 lg:py-20" data-testid="account-page">
        <p className="label-tiny mb-3">Your account</p>
        <h1 className="font-serif text-4xl text-[#2a2928] sm:text-5xl">Hi, {user.name.split(" ")[0]}</h1>
        <p className="mt-2 text-[#7a7571]">{user.email} · {user.phone}</p>

        <h2 className="mt-12 font-serif text-2xl">Your orders</h2>
        {loading ? (
          <div className="mt-6 text-[#7a7571]">Loading...</div>
        ) : orders.length === 0 ? (
          <div className="mt-6 rounded-3xl border border-dashed border-[#e8e2da] py-16 text-center text-[#7a7571]" data-testid="account-no-orders">
            No orders yet.{" "}
            <Link to="/shop" className="font-medium text-[#d08c8c] hover:underline">
              Browse hampers →
            </Link>
          </div>
        ) : (
          <div className="mt-6 space-y-4" data-testid="account-orders-list">
            {orders.map((o) => (
              <div key={o.id} data-testid={`account-order-${o.id}`} className="rounded-2xl border border-[#e8e2da] bg-white p-6">
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div>
                    <div className="font-serif text-lg">{o.order_number}</div>
                    <div className="text-xs text-[#7a7571]">
                      Placed {format(new Date(o.created_at), "PPP")} · {o.items.length} item(s)
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="rounded-full bg-[#faf1ee] px-3 py-1 text-xs font-medium text-[#d08c8c]">
                      {STATUS_LABEL[o.status] || o.status}
                    </span>
                    <span className="font-serif text-lg">{formatINR(o.total)}</span>
                  </div>
                </div>
                <div className="mt-4 border-t border-[#e8e2da] pt-4 text-sm text-[#7a7571]">
                  Deliver to {o.recipient_name} on {format(new Date(o.delivery_date), "PPP")} · {o.delivery_slot}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
